import { routes as auth } from '../modules/authentication'
import { routes as clinic } from '../views/pages/Clinic'
import { routes as commercial } from '../views/pages/Commercial'
import { routes as consultant} from '../views/pages/Consultant'
import { routes as doctor } from '../views/pages/Doctor'
import { routes as financial } from '../views/pages/Financial'
import { routes as patient } from '../views/pages/Patient'
import { routes as technology } from '../views/pages/Technology'
import { routes as helpdesk } from '../views/pages/HelpDesk'
import { routes as indicators } from '../views/pages/Indicators'
export default [
    ...auth,
    ...clinic,
    ...commercial,
    ...consultant,
    ...doctor,
    ...financial,
    ...patient,
    ...technology,
    ...helpdesk,
    ...indicators
]
